<template>
  <div>
    <el-row type="flex" justify="center">
      <el-col class="query-box" :span="16">
        <el-input
          v-model="playerName"
          placeholder="请输入你要查询的id 格式:xxx#1234"
        />
        <el-button
          type="primary"
          class="search-button"
          @click="queryPlayer"
        >查询</el-button>
      </el-col>
    </el-row>
    <el-row v-if="info">
      <template v-if="info.data">
        <el-row class="result-box">
          <div>
            <div style="display: flex">
              <el-avatar :src="getBungieImg(currentActivityIcon)" />
              <div class="activity-info">
                <div>
                  当前目的地: {{ activityMap[characterActivity.currentActivityHash].activityName }}
                </div>
                <div>
                  <!--            {{ activityMap[characterActivity.currentActivityHash] }}-->
                  已游玩时间: {{ characterActivity.dateActivityStarted |dateFormatter }}
                </div>
              </div>
            </div>
          </div>
          <el-col v-for="player in groupList" :key="player.membershipId">
            <GroupMemberInfo
              :membership-id="player.membershipId||''"
              :is-leader="player.status === 11"
            />
          </el-col>
        </el-row>
      </template>
      <template v-else>
        玩家不在线
      </template>
    </el-row>
  </div>
</template>

<script>
import { SearchDestinyPlayerByBungieName, GetProfile, Manifest, GetDefinition } from '@/api/bungie-api'
import GroupMemberInfo from '@/view/d2/conponents/group-member-info'

export default {
  name: 'CheckGroup',
  components: { GroupMemberInfo },
  filters: {
    dateFormatter(date) {
      // 计算与当前时间的时间差
      const time = new Date().getTime() - new Date(date).getTime()
      // 格式化 时 分 秒
      const hour = Math.floor(time / (1000 * 60 * 60))
      const minute = Math.floor((time - hour * 1000 * 60 * 60) / (1000 * 60))
      const second = Math.floor((time - hour * 1000 * 60 * 60 - minute * 1000 * 60) / 1000)
      return `${hour}小时${minute}分钟${second}秒`
    }
  },
  data() {
    return {
      playerName: undefined,
      info: undefined,
      activityMap: {},
      currentActivity: {},
      currentActivityIcon: '',
      currentPlayerMembershipId: undefined,
      currentPlayerMembershipType: undefined,
      characterActivity: undefined,
      groupList: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const url = localStorage.getItem('DestinyActivityDefinitionUrl')
      // 从棒鸡数据库里获得游玩模式
      Manifest().then(res => {
        const newUrl = res['jsonWorldComponentContentPaths']['zh-chs']['DestinyActivityDefinition']
        // save url to localstorage
        console.log(newUrl)
        if (newUrl !== url) {
          localStorage.setItem('DestinyActivityDefinitionUrl', newUrl)
          GetDefinition(newUrl).then(res => {
            const activityMap = {}
            console.log(res)
            for (const key in res) {
              const activity = res[key]
              activityMap[activity.hash] = {
                activityName: activity.displayProperties.name,
                icon: activity.displayProperties.icon,
                hasIcon: activity.displayProperties.hasIcon,
                activityTypeHash: activity.activityTypeHash
              }
            }
            localStorage.setItem('DestinyActivityDefinition', JSON.stringify(activityMap))
            this.activityMap = activityMap
          })
        } else {
          this.activityMap = JSON.parse(localStorage.getItem('DestinyActivityDefinition'))
        }
      })
    },
    queryPlayer() {
      let query
      try {
        query = this.getNameQuery(this.playerName)
      } catch (e) {
        this.$message.error('请输入正确的id格式,例如:xxx#1234')
        return
      }
      SearchDestinyPlayerByBungieName(query).then(response => {
        if (response && response.length > 0) {
          console.log(response[0])
          this.currentPlayerMembershipType = response[0]['membershipType']
          this.currentPlayerMembershipId = response[0]['membershipId']
          const params = {
            components: '100,200,204,1000,1100'
          }
          GetProfile(params, this.currentPlayerMembershipType, this.currentPlayerMembershipId).then(res => {
            console.log(res)
            this.info = res['profileTransitoryData']
            if (this.info['data']) {
              // this.currentActivity = this.info['data']['currentActivity']
              console.log(this.info)
              this.groupList = this.info['data']['partyMembers']
              // 获取当前游玩
              const profile = res['profile']['data']
              const characters = res['characters']['data']
              const characterActivities = res['characterActivities']['data']
              const dateLastPlayed = profile['dateLastPlayed']
              profile['characterIds'].forEach(id => {
                if (characters[id]['dateLastPlayed'] === dateLastPlayed) {
                  this.characterActivity = characterActivities[id]
                  this.currentActivityIcon = this.activityMap[this.characterActivity.currentActivityHash].icon
                  console.log(this.currentActivityIcon)
                }
              })
            } else {
              this.groupList = []
            }
            console.log(this.groupList)
          })
        }
      })
    },
    getNameQuery(name) {
      // const query = {
      //   // displayName: 'jiluo',
      //   // displayNameCode: '6477'
      //   displayName: '翻斗花园突破手：牛爷爷',
      //   displayNameCode: '117'
      // }
      // 将name 拆解为displayName displayNameCode
      const query = {}
      const nameArr = name.split('#')
      if (nameArr.length === 2) {
        query.displayName = nameArr[0]
        query.displayNameCode = nameArr[1]
        return query
      } else {
        throw new Error('name格式错误')
      }
    },
    getBungieImg(path) {
      if (path) {
        return `https://www.bungie.net${path}`
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
.search-button{
  margin-left: 10px;
  border-radius: 20px;
}
.query-box{
  display: flex;
}
.query-box ::v-deep .el-input__inner{
  border-radius: 20px;
}
.result-box{
  background-color: #add4f1;
  margin: 30px;
  padding: 10px;
  border-radius: 10px;
}
.activity-info{
  align-items: center;
  margin-left: 10px;
}
</style>
